import createIcon from '../../createIcon';

/**
 * @component @name HMobiledata
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUgMTFIOVY3SDdWMTdIOVYxM0gxNVYxN0gxN1Y3SDE1VjExWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const HMobiledata = createIcon('HMobiledata', [
  ['path', { d: 'M15 11H9V7H7V17H9V13H15V17H17V7H15V11Z', key: '1lx44o' }],
]);

export default HMobiledata;
